<template>
  <main class="destination">
    <div class="background-map">
      <AnimatedSwissMap />
    </div>

    <section class="content">
      <figure class="urs-welcome urs">
        <img src="../assets/urs_bubble.svg" />
        <figcaption>
          <p>Hi Melanie!</p>
          <p>
            Wohin fährst du heute?
          </p>
        </figcaption>
      </figure>

      <form class="name-form">
        <input type="text" name="username" placeholder="Start" class="form-control text-input" autocomplete="off">
        <input type="text" name="username" placeholder="Ziel" class="form-control text-input" autocomplete="off">
        <router-link to="/route" tag="button" class="form-control button-primary"><img src="../assets/icons/arrow_forward.svg" /></router-link>
      </form>
    </section>

  </main>
</template>

<script>
import AnimatedSwissMap from '@/components/AnimatedSwissMap.vue';

export default {
  name: 'destination',
  components: {
    AnimatedSwissMap,
  },
};
</script>

<style lang="scss">

.form-control{
  display: block;
  outline: none;
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: none;
  border: 1px solid#050711;
  box-shadow: inset -3px -3px 0 0 white, -5px -5px 0 #F8F6EB;
  background:#F8F6EB;
  font-family: inherit;
  font-weight: 600;

  &.text-input{
    width: 100%;
    font-size: 1.3rem;
    padding: 8px 18px;
  }
}

.button-primary{
  box-shadow: inset -3px -3px 0 0 white, -5px -5px 0 0#80CEC1;
  background:#80CEC1;
  cursor: pointer;
  padding:7px;

  img{
    display: block;
    height: 30px;
  }
}

.destination{
  position: relative;
  // min-height:100vh;
  display:flex;
  justify-content: center;
  align-items:center;

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width:100%;

    .name-form{
      display: flex;
      align-items: stretch;
      width: calc(100% - 30px);
      max-width: 450px;
      z-index: 102;

      input[type="text"]{
        margin-right:10px;
      }
    }

    .urs-welcome{
      position: absolute;
      display: block;
      bottom: -110px;
      left: 45%;
      z-index: -1;
      z-index: 101;
      animation-name: 'urs-welcome';
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-duration:1.5s;
      animation-timing-function: ease-in-out;
      transform-origin: 75% 100%;

      img{
        display: block;
        height: 460px;
      }

      figcaption{
        position: absolute;
        top: 0;
        width: 53%;
        left: 0;
        bottom: 63%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 27px;
        border-radius: 53%;
        flex-direction: column;
        text-align: center;

        p:not(:last-child){
          margin-bottom:5px;
        }
      }

      @keyframes urs-welcome {
        from {
          transform: rotate(0);
        }

        to {
          transform: rotate(1.5deg);
        }
      }
    }
  }
  .background-map{
    position: absolute;
    z-index: -1;
    top:0;
    left:0;
    right:0;
    bottom:0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg{
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      display:block;
      opacity: 0.5;
    }
  }
}

</style>
